import { typography } from '@/styles';
import styled from '@emotion/styled';
import { colors } from '@/styles';
import { Image } from 'react-bootstrap';
import { css } from '@emotion/react';
import { Grid } from '@material-ui/core';

export const Title = styled.span`
    ${typography.sansSerif}
    font-weight: 800;
    font-size: 28px;
    line-height: 1.25;
`;

export const SectionHeader = styled.span`
    ${typography.sansSerif}
    font-weight: 800;
    font-size: 20px;
`;

export const Body1 = styled.span`
    ${typography.sansSerif}
    ${(props) => props.error && `color: ${colors.reds.primary};`}
    font-weight: 500;
    font-size: 14px;
`;

export const Body2 = styled.span`
    ${typography.sansSerif}
    font-weight: 500;
    font-size: 14px;
    color: ${colors.greys.subtitle};
`;

export const Value = styled.span`
    ${typography.sansSerif}
    ${(props) => props.error && `color: ${colors.reds.primary};`}
    ${(props) => props.right && `text-align: right;`}
    width: 100%;
    font-weight: 700;
    font-size: 14px;
`;

export const Status = styled.span`
    ${typography.sansSerif}
    font-weight: 700;
    font-size: 14px;
    ${(props) =>
        props.color &&
        `
        color: ${props.color};
        border: 2px solid ${props.color};
        border-radius: 4px;
        padding: 6px 12px;
    `}
`;

export const File = ({ file }) => {
    return (
        <a href={file} target="_blank">
            <Image
                css={css`
                    height: 100px;
                    width: 100px;
                `}
                src={file}
            />
        </a>
    );
};

export const Card = ({ children, ...props }) => {
    return (
        <Grid
            container
            direction="column"
            css={css`
                width: 100%;
                flex-wrap: nowrap;
                padding: 1rem;
                border-radius: 0.5rem;
                background: white;
                border: 1px solid ${colors.greys.border};
                margin-bottom: 1rem;
            `}
            {...props}
        >
            {children}
        </Grid>
    );
};

export const Metric = ({ label, value, formatter, params = {} }) => {
    return (
        <Grid
            container
            direction="row"
            css={css`
                justify-content: space-between;
            `}
        >
            <Grid item xs={6}>
                <Body1>{label}</Body1>
            </Grid>
            <Grid
                item
                xs={6}
                css={css`
                    display: flex;
                    justify-content: flex-end;
                `}
            >
                <Value right>{formatter ? formatter(value, params) : value || '--'}</Value>
            </Grid>
        </Grid>
    );
};
